export type CebiaAutotracerAndReportCredentials = {
  username: string;
  password: string;
};
